module.exports = __webpack_public_path__ + "img/nj.4a79a54d.svg";